import { render } from "./PageHeader.component.vue?vue&type=template&id=251d109c&scoped=true&ts=true"
import script from "./PageHeader.component.vue?vue&type=script&lang=ts"
export * from "./PageHeader.component.vue?vue&type=script&lang=ts"

import "./PageHeader.component.vue?vue&type=style&index=0&id=251d109c&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251d109c"]])

export default __exports__